import { Model } from 'pinia-orm';
import { Str, Num, Bool, Uid } from 'pinia-orm/decorators';

/**
 * Pinia ORM model for storing Strapi pagination info per content type.
 */
export class StrapiPagination extends Model {
  static override entity = 'strapiPaginations';

  @Uid() declare id: number;
  @Str('') declare contentType: string; // e.g. 'courses', 'users', etc.
  @Num(1) declare page: number;
  @Num(25) declare pageSize: number;
  @Num(null) declare start: number | null;
  @Num(25) declare limit: number;
  @Bool(true) declare withCount: boolean;
  @Num(1) declare pageCount: number;
  @Num(null) declare total: number | null;

  // Computed property to check if this is the last page
  get isLast(): boolean {
    return !!(this.start && this.total && this.start >= this.total);
  }

  // Optionally, you can add computed properties or methods here
}
